<template>
  <a class="show-hide" @click="onClick">
    <i
      :class="['af-icons', 'af-icons-' + (isVisible ? 'read-off' : 'preview')]"
    ></i>
    {{ text }}
  </a>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    hideText: {
      type: String,
      default: 'Hide'
    },
    showText: {
      type: String,
      default: 'Show'
    }
  },
  data() {
    return {
      isVisible: this.visible
    };
  },
  computed: {
    text() {
      return this.isVisible ? this.hideText : this.showText;
    }
  },
  methods: {
    onClick() {
      this.isVisible = !this.isVisible;
      this.saveVisibilitySetting(this.isVisible);
    },
    saveVisibilitySetting(isVisible) {
      const data = { visible: isVisible };
      this.$http.post(this.url, data);

      this.$emit('change', isVisible);
    }
  }
};
</script>

<style scoped>
.show-hide {
  text-decoration: none;
}
</style>
